import React from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { GTM_ID } from '../../../../../common/constants/gtmIds';

const GcDropDown = ({ sortedLinks }) => {
  return (
    <select
      data-testid="gc-dropdown"
      data-gtm-id={GTM_ID.FILTER_SELECT}
      onBlur={event => navigate(event.target.value)}
    >
      <option>Choose another in this category</option>
      {Array.isArray(sortedLinks) &&
        sortedLinks.map((link, index) => {
          return (
            <option
              data-testid="select-option"
              key={link.name}
              value={link.url}
            >
              {link.name}
            </option>
          );
        })}
    </select>
  );
};

GcDropDown.propTypes = {
  sortedLinks: PropTypes.array,
};

const StyledGcDropDown = styled(GcDropDown)`
  select {
    padding: 1rem 1rem 0.8rem 1rem;
  }
`;
export default StyledGcDropDown;
